/**
 * Maps aiDesign nav IDs to app routes and defines section structure.
 * Used by AppLayout Sidebar to match aiDesign design while using app routes.
 */
export const ID_TO_ROUTE = {
  "company-view": "/company-view",
  "company-metrics": "/company-metrics",
  home: "/home",
  dash: "/home",
  "gameboard-library": "/gameboard-library",
  gameboard: "/gameboard-library",
  "bad-guy": "/bad-guy",
  "team-room": "/team-room",
  "workspace-kpi": "/workspace-kpi",
  metrics: "/workspace-kpi",
  "company-details": "/settings/company-details",
  players: "/settings/players",
  "level-up": "/settings/level-up",
  "tv-view": "/settings/tv-view",
  "manage-widgets": "/widgets",
  settings: "/settings",
  hub: "/hub",
  scorekeeper: "/scorekeeper",
  scorecard: "/scorekeeper/timeline?player=true",
  claims: "/claims",
  feed: "/feed",
  messages: "/messages",
  "challenge-arena": "/challenge-arena",
  levelup: "/levelup",
  widgets: "/widgets",
  "affiliate-hub": "/affiliates",
  affiliates: "/affiliates",
};

/**
 * Get the active nav key from current pathname (for highlighting).
 */
function norm(pathStr) {
  return pathStr?.startsWith("/") ? pathStr : `/${pathStr || ""}`;
}

function pathMatches(path, routePath) {
  const r = norm(routePath);
  return path === r || path.startsWith(r + "/");
}

export function getActiveKeyFromPathname(pathname, routes) {
  const path = pathname.split("?")[0];
  const subMatch = routes.reduce((acc, r) => {
    if (acc) return acc;
    const sub = r.collapse?.find((s) => pathMatches(path, s.route));
    return sub ? sub.key : null;
  }, null);
  if (subMatch) return subMatch;
  const main = routes.find((r) => r.route && pathMatches(path, r.route));
  if (main) return main.key;
  const segment = path.split("/").filter(Boolean)[0];
  return segment || "home";
}
